import { faChevronRight } from '@fortawesome/pro-light-svg-icons'
import { QuoteOrderModelType } from '@teinor/erp/types/company/order/quote/quoteOrder'
import { useCallback, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { RenderQuoteStatus } from '../../../app/erp/screens/Logistic/QuoteParent/subcomponents'
import { DisplayPriceGettingParams } from '../../../baseComponents/Displays/DisplayPrice'
import TwinIcon from '../../../baseComponents/TwinIcon'
import { VirtualTableListingStateLess } from '../../../baseComponents/TwinTable/VirtualTableListing'
import { CustomRenderString, CustomRenderDate } from '../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { ColumnTableSchema } from '../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import TwinTrans from '../../../baseComponents/TwinTrans'
import { twinFetchPostJSON } from '../../../utils/globals/data'
import locations from '../../../utils/globals/locations'
import useEditDeleteModal from '../../../utils/hooks/useEditDeleteModal'
import useTwinTranslation from '../../../utils/hooks/useTwinTranslation'
import ModalCampaignCustomerCreateQuote from './ModalCampaignCustomerCreateQuote'
import { CampaignCustomerModelType } from '@teinor/erp/types/company/customer/campaign/campaignCustomer'

interface CampaignCustomerQuoteTabProps extends CampaignCustomerQuoteTabLogicProps {
    getData: () => Promise<void>
}

const CampaignCustomerQuoteTab: React.FC<CampaignCustomerQuoteTabProps> = ({ campaignCustomerData, getData }) => {
    const { quotes, setOpenModal, openModal } = useCampaignCustomerQuoteTabLogic({ campaignCustomerData })
    const { t } = useTwinTranslation()
    const columns: ColumnTableSchema<QuoteOrderModelType> = [
        {
            id: 'full_assigned_number',
            dataKey: 'full_assigned_number',
            label: t('orderQuoteP', 'Pedido'),
            customRender: (parameterValue, allRowData) => <CustomRenderString value={parameterValue} className={allRowData?.assigned_number ? '' : 'text-red-BA'} />,
        },
        {
            id: 'version',
            dataKey: 'version',
            label: t('version', 'Versión'),
            width: 90,
            customRender: (parameterValue, allRowData) => <CustomRenderString value={parameterValue || allRowData.version} />,
        },
        {
            id: 'status',
            dataKey: 'status',
            label: t('status', 'Estado'),
            minWidth: 130,
            customRender: (parameterValue) => <RenderQuoteStatus value={parameterValue} />,
        },
        {
            id: 'WorkingCenterId',
            dataKey: 'WorkingCenterId',
            searchKey: 'WorkingCenter.name',
            label: t('workingCenter', 'Centro de trabajo'),
            customRender: (_parameterValue, allRowData) => <CustomRenderString value={allRowData?.WorkingCenter?.name || ''} />
        },
        {
            id: 'processed_date',
            dataKey: 'processed_date',
            label: t('createdDate', 'Fecha de creación'),
            customRender: (parameterValue, allRowData) => <CustomRenderDate value={parameterValue || allRowData.createdAt} className={parameterValue ? '' : 'text-red-BA'} />,
            minWidth: 180,
        },
        {
            id: 'total_total',
            dataKey: 'total_total',
            label: t('total', 'Total'),
            customRender: (parameterValue, allRowData) => allRowData?.hidePrices ? <div>-</div> : <DisplayPriceGettingParams value={parseFloat(parameterValue)} with_vat={allRowData.with_vat} CurrencyId={allRowData.CurrencyId} />,
        },
        {
            id: 'arrow',
            dataKey: 'id',
            label: '',
            width: 50,
            customRender: (parameterValue, allRowData) =>
                <Link to={locations.quoteOrderSingle + '/' + parameterValue}><TwinIcon icon={faChevronRight} /></Link>
        },
    ]
    return (
        <div className='flex flex-col flex-auto gap-20'>
            <div className='flex'>
                <button className='text-green-43 mt-20 ml-auto' onClick={() => setOpenModal({ type: 'create', allRowData: campaignCustomerData })}><TwinTrans transKey='addQuote'>Agregar presupuesto</TwinTrans></button>
            </div>
            <VirtualTableListingStateLess tableData={quotes} columns={columns} setSelectedColumnsAndFilters={() => { }} name={'CampaignCustomerQuoteTabTable'} />
            {openModal?.type === 'create' ? <ModalCampaignCustomerCreateQuote allRowData={openModal.allRowData} setOpened={() => setOpenModal(null)} onSubmit={getData} /> : null}
        </div>
    )
}

interface CampaignCustomerQuoteTabLogicProps {
    campaignCustomerData: CampaignCustomerModelType
}

const useCampaignCustomerQuoteTabLogic = ({ campaignCustomerData }: CampaignCustomerQuoteTabLogicProps) => {
    const { openModal, setOpenModal } = useEditDeleteModal()
    const [quotes, setQuotes] = useState<QuoteOrderModelType[] | null>(null)
    const getQuotesData = useCallback(async () => {
        const result = await twinFetchPostJSON('/api/app/order/quote/getAllQuoteOrdersComplete', {
            where: {
                CampaignCustomerId: campaignCustomerData.id,
                'Customer.id': campaignCustomerData.CustomerId,
                is_last: true
            }
        })
        if (result) {
            setQuotes(result)
        }
    }, [setQuotes, campaignCustomerData.id, campaignCustomerData.CustomerId])

    useEffect(() => {
        getQuotesData()
    }, [getQuotesData])

    return { quotes, getQuotesData, setOpenModal, openModal }
}

export default CampaignCustomerQuoteTab